import { SiteDataProvider } from '@/context/SiteDataProvider'
import { ReactNode } from 'react'
import Banner from './Banner'
import Footer from './Footer'
import Header from './Header'
import SkipToContent from './SkipToContent'

interface LayoutProps {
  children: ReactNode
  siteData?: unknown
}

export default function Layout({ children, siteData }: LayoutProps) {
  return (
    <SiteDataProvider initialData={siteData}>
      <SkipToContent />
      <Banner />
      <Header />
      <div id="main-content" className="content" style={{ minHeight: '100vh' }}>
        {children}
      </div>
      <Footer />
    </SiteDataProvider>
  )
}
